import { render } from "./editCharade.vue?vue&type=template&id=467d5c04&scoped=true"
import script from "./editCharade.vue?vue&type=script&lang=js"
export * from "./editCharade.vue?vue&type=script&lang=js"

import "./editCharade.vue?vue&type=style&index=0&id=467d5c04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467d5c04"]])

export default __exports__